export default "__VITE_ASSET__BF049IWf__"